module.exports = __webpack_public_path__ + "static/img/painting_machine.23149997.png";